import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=1667a27b&scoped=true&"
import script from "./Informacion.vue?vue&type=script&lang=js&"
export * from "./Informacion.vue?vue&type=script&lang=js&"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=1667a27b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1667a27b",
  null
  
)

export default component.exports